export const stories = [
  {
    id: 4,
    slug: "sri-lanka-loan-2026",
    title: "Is This a Good Time to Take a Loan in Sri Lanka?",
    subtitle:
      "El Niño is arriving. The Middle East conflict is reshaping global energy. Interest rates are floating. Here is what every Sri Lankan borrower needs to understand before signing a loan agreement in 2026.",
    date: "2026-06-14",
    category: "Finance",
    coverImage: "/stories/sri-lanka-loan-cover.svg",
    tags: ["Sri Lanka", "Personal Finance", "Economics"],
    source: "html",
    htmlSrc: "/stories/sri-lanka-loan.html",
  },
  {
    id: 3,
    slug: "ironman-colombo-swim-training-plan",
    title: "Journal #2 — Day 1 in the Pool",
    subtitle:
      "I swam as a kid — one length, 25 metres, with my arms. Today I got back in for the first time in years. Here's what happened.",
    date: "2026-06-06",
    category: "Zero to IRONMAN",
    coverImage: "/swim-day1-kickboard.jpg",
    coverImagePosition: "top",
    tags: ["Zero to IRONMAN", "Swimming"],
    source: "html",
    htmlSrc: "/stories/swim-day1.html",
  },
  {
    id: 2,
    slug: "ironman-colombo-the-beginning",
    title: "Journal #1 — Planning to Sign Up for IRONMAN Colombo",
    subtitle:
      "What is IRONMAN, how it started, what the race actually looks like, and why I'm seriously considering doing this.",
    date: "2026-06-01",
    category: "IRONMAN",
    coverImage:
      "https://instagram.fcmb12-1.fna.fbcdn.net/v/t51.82787-15/607642522_17867455005548777_7403406257729777275_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=102&ig_cache_key=Mzc5ODgzNjEyOTU1NTA5MzQ4Mw%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6IkNBUk9VU0VMX0lURU0ueHBpZHMuMTA4MC5zZHIucmVndWxhcl9waG90by5DMyJ9&_nc_ohc=ib4JmI8VEX8Q7kNvwF_cHuO&_nc_oc=AdrJwKdyJgyqt5tPc49lqpRfflfgZ6S7JxJkXIXTFxYxg66bIQbnn7TCy80QXjYfdzpUyzJIQ8zG6pE5PnstSVrQ&_nc_ad=z-m&_nc_cid=1017&_nc_zt=23&_nc_ht=instagram.fcmb12-1.fna&_nc_gid=EACS_dsHmcrAnZXrrcKEOQ&_nc_ss=7a22e&oh=00_Af_qJuvniYnp1tAVFwU-ZzBf0jDXds_KVG1-udK-BXZC8Q&oe=6A296A20",
    coverImagePosition: "top",
    tags: ["IRONMAN", "Triathlon", "Colombo"],
    source: "html",
    htmlSrc: "/stories/ironman-beginning.html",
  },
];
